import { ReactElement } from 'react'
import art from './assets/arte.png'
import * as S from './styled'

export default function Intro (): ReactElement {
  return <S.Container>
    <S.InfoContainer>
      <S.InfoContent>
        <h1>O Esportes Soft</h1>

        <p>
          oferece desconto em <span>consultas médicas</span>, <span>exames</span>, <span>farmácias</span> e <span>cursos na Refuturiza</span>, além de <span>experiências exclusivas com seu time do coração</span>. Todos os benefícios do programa são acoplados ao sócio-torcedor do seu time do coração.
        </p>

        <a href="#como-funciona" target="_self">
          <button>
            Saiba mais
          </button>
        </a>
      </S.InfoContent>

      <figure className="desktop">
        <img src={art} alt="" />
      </figure>

      <figure className="mobile">
        <img src={art} alt="" />
      </figure>
    </S.InfoContainer>
  </S.Container>
}
